import { render, staticRenderFns } from "./MentionFolder.html?vue&type=template&id=a5648e70&scoped=true&"
import script from "./MentionFolder.js?vue&type=script&lang=js&"
export * from "./MentionFolder.js?vue&type=script&lang=js&"
import style0 from "./MentionFolder.scss?vue&type=style&index=0&id=a5648e70&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5648e70",
  null
  
)

export default component.exports